var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import padding from "@irati/ui/src/global/padding";
import { minWidthMedia } from "@irati/ui/src/global/media";
import { FlexRow as FlexRowBase, BodyContainer as BodyContainerBase } from "../../../shared";
export var IconsRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
export var FlexRow = styled(FlexRowBase)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: start;\n  ", "\n  ", "\n"], ["\n  align-items: start;\n  ", "\n  ",
    "\n"])), function (_a) {
    var isPrivate = _a.isPrivate;
    return isPrivate && "padding-top: 12px;";
}, minWidthMedia.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isPrivate = _a.isPrivate;
    return isPrivate && "padding-top: 0px;";
}));
export var BodyContainer = styled(BodyContainerBase)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: ", ";\n  ", "\n"], ["\n  margin-left: ", ";\n  ",
    "\n"])), padding.tiny, minWidthMedia.tablet(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), padding.base));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
